module.exports = __webpack_public_path__ + "img/dragonfly.7877d7cf.png";